import type { ReactNode } from 'react';

import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
} from '@mint-lib/tw-components';

type TemplateDrawerProps = Readonly<{
  children: ReactNode;
  open: boolean;
  onClose: () => void;
}>;

export const TemplateDrawer = ({
  children,
  open,
  onClose,
}: TemplateDrawerProps) => (
  <Drawer open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerRoot
        side="right"
        className="max-w-[720px] overflow-y-auto"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <DrawerContent className="h-auto min-h-full flex-col px-4 pt-4 pb-2">
          {children}
        </DrawerContent>
      </DrawerRoot>
    </DrawerPortal>
  </Drawer>
);
